export const required = (val: string | null): boolean | string =>
  Boolean(val && val.length > 0) || 'Obligatorisk'
